export * from './IconFolderEmpty';
